import type React from 'react';
import { QueryProvider } from '@/providers/query-provider';
import { I18NextProviderClient } from '@/components/i18next-provider';
import { ThemeProvider as NextThemesProvider } from 'next-themes';
import { ThemeProvider } from '@/contexts/theme-context';
import { UserProvider } from '@/contexts/user-context';
import { GymProvider } from '@/contexts/gym-context';
import { BrandingProvider } from '@/contexts/branding-context';
import { PointerEventsProvider } from '@/components/providers/pointer-events-provider';
import { GlobalConfirmationDialog } from '@/components/shared/global-confirmation-dialog';
import { ToastProvider } from '@/components/toast-provider';
import { Toaster } from '@/components/ui/sonner';

export function RootLayout({ children }: { children: React.ReactNode }) {
  return (
    <PointerEventsProvider>
      <QueryProvider>
        <NextThemesProvider
          attribute="class"
          defaultTheme="light"
          enableSystem
        >
          <ThemeProvider>
            <UserProvider>
              <GymProvider>
                <BrandingProvider>
                  <I18NextProviderClient>
                    {children}
                    <ToastProvider />
                    <Toaster position="top-right" richColors />
                  </I18NextProviderClient>
                </BrandingProvider>
              </GymProvider>
            </UserProvider>
          </ThemeProvider>
        </NextThemesProvider>
      </QueryProvider>
      <GlobalConfirmationDialog />
    </PointerEventsProvider>
  );
}
